import React from "react";
import CustomTable from "../../helpers/customtable";
import MillingImage from "./MillingImage";

export default function MillingsList({ millings, loading, onEdit }) {
  const rows = millings.map((m) => ({ ...m, variantNames: (m.variants || []).map((v) => v.name).join(", ") }));
  return <CustomTable data={rows} loading={loading} config={{ rowKey: "millingId", showPageSizeSelector: true, showTotalCount: true,
    onRowClick: onEdit, columns: [
      { key: "millingId", header: "Azonosító" },
      { key: "imageKey", header: "Kép", sortable: false, filterable: false, render: (key, row) => <MillingImage imageKey={key} name={row.name} /> },
      { key: "name", header: "Név" },
      { key: "dxfKey", header: "DXF", formatValue: (v) => v ? "Van" : "", default: "—" },
      { key: "materialType", header: "Anyag" },
      { key: "active", header: "Aktív", formatValue: (v) => v ? "Igen" : "Nem" },
      { key: "variantNames", header: "Változatok", default: "—" }
    ] }} />;
}
